import { render } from "./country-select.vue?vue&type=template&id=f2054be2"
import script from "./country-select.vue?vue&type=script&lang=js"
export * from "./country-select.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__